<template lang="pug">
  div(class="container")
    line-chart(v-if="loaded" :chartdata="chartdata" :options="options")
    div(class="text-center" v-if="!loaded").mt-12
      v-progress-circular(indeterminate class="mb-2" :size="50" :width="5" color="primary")
    
</template>

<script>
import LineChart from "../LineChart";
import moment from "moment";

export default {
  name: "ServiceRequest",
  props: ["filter", "groupby", "duration"],
  components: { LineChart },
  data: () => ({
    loaded: false,
    chartdata: Object,
    options: Object,
    year: new Date().getFullYear()
  }),
  async mounted() {
    this.buildData();
  },
  methods: {
    buildData() {
      this.getData()
        .then(this.filterData)
        .then(this.groupData)
        .then(this.sortData)
        .then(this.plotData);
    },
    getData() {
      return new Promise(resolve => {
        fetch(
          `https://datahub-v2.arlingtonva.us/api/Environmental/Service+Request?$top=10000&$orderby=createdAt desc`
        ).then(response => {
          resolve(response.json());
        });
      });
    },
     filterData(data) {
      if (this.interval !== "yearly") {
        return data.filter(d => {
          return new Date(d.createdAt).getFullYear() === this.year;
        });
      } else {
        return data;
      }
    },
     groupData(data) {
      return data.reduce((d, { createdAt }) => {
        let monthyear =
          this.interval === "yearly"
            ? moment.utc(createdAt).format("YYYY")
            : moment.utc(createdAt).format("MM/01/YYYY");
        if (!d[monthyear]) d[monthyear] = { monthyear, entries: 1 };
        else {
          d[monthyear].entries++;
        }
        return d;
      }, []);
    },

    sortData(data) {
      return Object.values(data).sort(function(a, b) {
        return new Date(a.monthyear) - new Date(b.monthyear);
      });
    },

    plotData(data) {
      this.chartdata = {
        //Data to be represented on x-axis
        labels: [...data.map(d => moment.utc(d.monthyear).format("MMM YYYY"))],
        datasets: [
          {
            label: "Incident count",
            backgroundColor: "#005cbb",
            pointBackgroundColor: "white",
            borderWidth: 3,
            pointBorderColor: "#249EBF",
            fill:false,
            //Data to be represented on y-axis
            data: [...data.map(d => Math.round(d.entries))]
          }
        ]
      };

      this.options = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: true,
                labelString: "Incidents Reported via PublicStuff"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              },
              scaleLabel: {
                display: true,
                labelString: "Period"
              }
            }
          ]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      };
      this.loaded = true;
    }
  },

  computed: {},
  watch: {
    year: function() {
      this.buildData();
    }
  }
};
</script>